/**
 * Motor regional puro: resuelve configuraciones y redondeos físicos.
 * No persiste cambios ni aplica métodos de pago para preservar la separación de módulos.
 */

import { COUNTRY_CONFIGS } from "./catalog";
import type { CashRoundingResult, CountryCode, CountryConfig } from "./types";

export const DEFAULT_COUNTRY_CODE: CountryCode = "CO";

export const isCountryCode = (value: unknown): value is CountryCode =>
  typeof value === "string" && value in COUNTRY_CONFIGS;

export const getCountryConfig = (country?: unknown): CountryConfig =>
  COUNTRY_CONFIGS[isCountryCode(country) ? country : DEFAULT_COUNTRY_CODE];

export const getCurrencyFractionDigits = (country?: unknown): number =>
  getCountryConfig(country).currency.decimalPlaces;

export const cashDenominationValues = (
  config: Pick<CountryConfig, "bills" | "coins">,
): readonly number[] => [...config.bills, ...config.coins];

export const roundToPhysicalUnit = (
  amount: number,
  country?: unknown,
): CashRoundingResult => {
  const config = getCountryConfig(country);
  const unit = config.smallestPhysicalUnit;
  const decimalScale = 10 ** config.currency.decimalPlaces;
  const roundedAmount =
    Math.round(Math.round(amount / unit) * unit * decimalScale) / decimalScale;

  return {
    originalAmount: amount,
    roundedAmount,
    adjustment:
      Math.round((roundedAmount - amount) * decimalScale) / decimalScale,
  };
};
